import { FaMapMarkerAlt, FaRegCalendar, FaRegClock } from "react-icons/fa";

const EventDetailsList = ({ event, isSearchResult }) => {
	let classes = "font-light text-gray-500";

	if (isSearchResult) {
		classes += " text-xs leading-6  my-1 ml-2 @md:ml-5";
	} else {
		classes += " text-sm leading-6  my-3 ml-5";
	}

	return (
		<ul className={classes}>
			<li>
				{event.isOnNow && event.multiDay && (
					<>
						<FaRegCalendar className="inline-block -mt-1 mr-1" /> To{" "}
						{event.endDateDesc}
					</>
				)}
				{!(event.isOnNow && event.multiDay) && (
					<>
						<FaRegClock className="inline-block -mt-1 mr-1" /> {event.timeDesc}
					</>
				)}
			</li>
			{event.locationSummary && (
				<li className="line-clamp-1">
					<FaMapMarkerAlt className="inline-block -mt-1 mr-2" />
					{event.locationSummary}
				</li>
			)}
		</ul>
	);
};

export default EventDetailsList;
